module.exports = __webpack_public_path__ + "static/img/icon_yajin.466b78c7.png";